export enum BtnActions {
  GO_BACK = 'GO_BACK',
  GO_NEXT = 'GO_NEXT',
  GO_HOME = 'GO_HOME',
  KEEP_ON_PAGE = 'KEEP_ON_PAGE'
}
export type ViewError = Readonly<{
  title: string;
  text: string;
  textSecondary?: string;
  btnText: string;
  btnAction: BtnActions;
}>;

export type ViewErrors = {[key: string]: ViewError};
